import * as R from 'ramda';
import { inject, observer } from 'mobx-react';

import { Loader } from './Loader';

export const LoaderContainer = R.compose(
  inject(({ rootStore }) => ({ image: rootStore?.userTheme ? rootStore.userTheme.spinner : null })),
  observer,
)(Loader);
